import { UserLog } from '../../admin/types/UserLog';
import { setUser } from '../stores/modelSlice';
import { SavedCode } from '../types/Codes';
import { RenameByT } from '../types/HelperTypes';
import { PaginatedResponse } from '../types/PaginatedResponse';
import { PaginationParams } from '../types/PaginationParams';
import { SaveSheet, SheetStatus } from '../types/SaveSheet';
import { CurrentUser } from '../types/User';

import { ENDPOINTS } from './endpoints';

import apiInstance from '.';

const commonApi = apiInstance.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getMe: builder.mutation<CurrentUser, void>({
      query: () => ({
        url: `${ENDPOINTS.user}`,
        method: 'GET',
      }),
      transformResponse: (response: { user: CurrentUser }) => response.user,
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUser(data));
        } catch (err) {
          console.log(err);
        }
      },
    }),
    getRoleList: builder.query<string[], void>({
      query: () => ({
        url: `${ENDPOINTS.getRoleList}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 500,
      transformResponse: (response: { roles: string[] }) => response.roles,
    }),
    getSpecialtyList: builder.query<string[], void>({
      query: () => ({
        url: `${ENDPOINTS.getSpecialtyList}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 500,
      transformResponse: (response: { spicialities: string[] }) =>
        response.spicialities,
    }),
    getFavoriteCodes: builder.query<SavedCode[], void>({
      query: (id) => ({
        url: `${ENDPOINTS.favoriteCodes}`,
        method: 'GET',
      }),
      transformResponse: (response: { savedCodes: SavedCode[] }) =>
        response.savedCodes?.reverse(),
      providesTags: ['FavoriteCodes'],
    }),
    addLog: builder.mutation<UserLog, string>({
      query: (action) => ({
        url: `${ENDPOINTS.addLog}`,
        method: 'POST',
        body: {
          action,
        },
      }),
    }),
    getSavedNotes: builder.query<
      RenameByT<{ docs: 'savedSheets' }, PaginatedResponse<SaveSheet>>,
      PaginationParams & {
        status?: SheetStatus;
        clinicNotes?: boolean;
        searchQuery?: string;
      }
    >({
      query: (params) => ({
        url: `${ENDPOINTS.notes}`,
        method: 'GET',
        params,
      }),
      providesTags: ['SavedSheets'],
    }),
  }),
});

export const {
  useGetMeMutation,
  useGetFavoriteCodesQuery,
  useGetRoleListQuery,
  useGetSpecialtyListQuery,
  useAddLogMutation,
  useGetSavedNotesQuery,
  usePrefetch,
} = commonApi;
export default commonApi;
